import classNames from 'classnames';

export interface RibbonLabelProps {
  label: string;
  type: 'golden' | 'biancone' | 'beige' | 'pink' | 'white';
  className?: string;
  width?: string;
  isUnitPreconstruction?: boolean;
  statusCode?: 'R' | 'CS';
  color?: string;
  isRibbonLast?: boolean;
  isMobile?: boolean;
}

export const RibbonLabel: React.FC<RibbonLabelProps> = ({
  label,
  type,
  width,
  statusCode,
  isRibbonLast,
  isMobile,
}) => {
  const isRibbonWithClipPath = isMobile || (isRibbonLast && !isMobile);

  const getClipPath = () => {
    if (isRibbonWithClipPath) {
      return 'polygon(100% 0px, 0px 0px, 0px 100%, 100% 100%, calc(100% - 20px) 50%)';
    }
    return '';
  };

  const getPaddingClass = () => {
    if (isRibbonWithClipPath) {
      return 'pr-8';
    }
    return 'pr-4';
  };

  return (
    <div
      className={classNames(
        'flex justify-left',
        'flex-shrink-0 w-fit',
        `pl-2 py-1 md:py-[10px] lg:pl-4 mt-[2px] ${getPaddingClass()}`,
        {
          'bg-[#E8D891]': type === 'golden',
          'bg-[#F2D1B4]': type === 'biancone',
          'bg-[#EAE8E5]': type === 'beige',
          'bg-[#FFE1DF]': type === 'pink',
          'bg-white': type === 'white',
        }
      )}
      style={{
        clipPath: getClipPath(),
        zIndex: -1,
        ...(width && !isMobile && { width }),
      }}
    >
      <span className="font-sohneBreitHalbfett text-12-18-0.3 md:text-16-26-0.3 z-10 whitespace-nowrap">
        {label}
      </span>
    </div>
  );
};
